export default {
	releaseManage: 'Releaseverwaltung',
	deleteSelected: 'Auswahl löschen',
	release: 'freigeben',
	deactive: 'deaktivieren'
}
